import React from 'react';
import Overview from '@hpstellar/pdp/Overview';
import KeySellingPoints from '@hpstellar/pdp/KeySellingPoints';

import withPageComponents from '../../../page/components/with-page-components';

import './pdp-overview.less';

const pdpOverview = ({ product, pdpFeatures, category }) => {
    if (pdpFeatures && product) {
        const { attributes } = product;
        const { pm_category = '' } = attributes;
        const { keyPoints, summary, bulletPoints } = pdpFeatures;
        const categoryName = pm_category.toLowerCase();

        // TODO: empty array was adding bulletpoint section to mobile,
        // not sure if we should handle this or stellar should check for empty array.
        let _bulletPoints = bulletPoints;
        if (_bulletPoints && _bulletPoints.length === 0) _bulletPoints = undefined;

        return (
            <div className="pdp-overview">
                <Overview productCategory={category} bulletPoints={_bulletPoints} description={summary} title="" />
                {keyPoints && keyPoints.length > 0 && (
                    <KeySellingPoints
                        data={pdpFeatures.keyPoints}
                        className={categoryName.indexOf('services') > -1 ? 'services' : undefined}
                    />
                )}
            </div>
        );
    }
    return null;
};

export default withPageComponents(pdpOverview, { components: ['product', 'pdpFeatures'] });
